import {zapi} from '../__internal__/http-client/index.js';

import * as endpoints from './endpoints.js';

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.5+-+Live+and+Recorded+Content#2.2.5-LiveandRecordedContent-watchlive
 * @param {$ZAPI.Stream.WatchLiveRequest} data
 * @returns {Promise<$ZAPI.Stream.WatchResponse>}
 */
export const getLiveStream = ({cid, ...data}) => zapi({
    path: `watch/live/${cid}`,
    method: 'post',
    endpointID: endpoints.STREAM_LIVE_RECEIVED,
    retryOn50X: true,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.5+-+Live+and+Recorded+Content#2.2.5-LiveandRecordedContent-watchrecording
 * @param {$ZAPI.Stream.WatchRecordingRequest} data
 * @returns {Promise<$ZAPI.Stream.WatchResponse>}
 */
export const getRecordingStream = ({recording_id, ...data}) => zapi({
    path: `watch/recording/${recording_id}`,
    method: 'post',
    endpointID: endpoints.STREAM_RECORDING_RECEIVED,
    retryOn50X: true,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.5+-+Live+and+Recorded+Content#2.2.5-LiveandRecordedContent-watchreplay
 * @param {$ZAPI.Stream.WatchReplayRequest} data
 * @returns {Promise<$ZAPI.Stream.WatchResponse>}
 */
export const getReplayStream = ({cid, program_id, ...data}) => zapi({
    path: `v3/watch/replay/${cid}/${program_id}`,
    method: 'post',
    endpointID: endpoints.STREAM_REPLAY_RECEIVED,
    retryOn50X: true,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.5+-+Live+and+Recorded+Content#2.2.5-LiveandRecordedContent-WatchAVODVideo
 * @param {$ZAPI.Stream.WatchAVODRequest} data
 * @returns {Promise<$ZAPI.Stream.WatchResponse>}
 */
export const getAVODStream = ({token, ...data}) => zapi({
    path: `avod/videos/${token}/watch`,
    method: 'post',
    endpointID: endpoints.STREAM_AVOD_RECEIVED,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.14+-+Registered+Timeshift#2.2.14-RegisteredTimeshift-RegisterTimeshift
 * @param {$ZAPI.Stream.RegisterTimeshiftRequest} data
 * @returns {Promise<$ZAPI.Stream.RegisterTimeshiftResponse>}
 */
export const registerTimeshift = ({cid, ...data}) => zapi({
    path: `timeshift/register/${cid}`,
    method: 'post',
    endpointID: endpoints.STREAM_TIMESHIFT_REGISTERED,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.14+-+Registered+Timeshift#2.2.14-RegisteredTimeshift-RegisterTimeshift
 * @param {$ZAPI.Stream.WatchTimeshiftRequest} data
 * @returns {Promise<$ZAPI.Stream.WatchResponse>}
 */
export const getTimeshiftStream = ({cid, ...data}) => zapi({
    path: `timeshift/watch/${cid}`,
    method: 'post',
    endpointID: endpoints.STREAM_TIMESHIFT_RECEIVED,
    data,
});

/**
 * @param {$ZAPI.Stream.WatchVODVideoRequest} data
 * @returns {Promise<$ZAPI.Stream.WatchResponse>}
 */
export const getVOD = (data) => zapi({
    path: 'watch/vod/video',
    method: 'post',
    endpointID: endpoints.STREAM_VOD_RECEIVED,
    data,
});

/**
 * @param {$ZAPI.Stream.WatchVODTrailerRequest} data
 * @returns {Promise<$ZAPI.Stream.WatchResponse>}
 */
export const getVODTrailer = (data) => zapi({
    path: 'watch/vod/trailer',
    method: 'post',
    endpointID: endpoints.STREAM_VOD_TRAILER_RECEIVED,
    data,
});
